import { ApiType } from "@gymflow/common";
import { portalIsLocalhost } from "@gymflow/helpers";
import { useQuery } from "@tanstack/react-query";
import { featureFlagOverrideMap } from "libs/types/src/featureFlags";

import { clubAsPublicQueryKeys } from "./clubAsPublicQueryKeys";

export function useClubPropertiesSettingsAsPublic({ api }: { api: ApiType }) {
  return useQuery({
    queryKey: clubAsPublicQueryKeys.propertiesSettings(),
    queryFn: async () => {
      const propertiesSettings = (await api.public.clubApi.propertiesSettings())
        .data;
      const featureFlags = {
        ...propertiesSettings.featureFlags,
        ...(portalIsLocalhost() ? featureFlagOverrideMap.portal : {}),
      };
      return {
        ...propertiesSettings,
        featureFlags,
      };
    },
  });
}
